import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { searchApi } from "../../services/search.api";
import { AppointmentSearchResponse } from "../../types/appointment.definition";
import { SearchRequest } from "../../types/search.definition";
import {
  fetchAppointmentsFailure,
  fetchAppointmentsRequest,
  fetchAppointmentsSuccess,
} from "../reducers/appointmentSlice";

function* fetchAppointmentsSaga({
  payload,
}: PayloadAction<{ facilityId: number; searchRequest: SearchRequest }>): Generator<
  unknown,
  void,
  AppointmentSearchResponse
> {
  try {
    const response = yield call(
      searchApi.searchAppointmentsInFacility,
      payload.searchRequest,
      payload.facilityId
    );

    yield put(
      fetchAppointmentsSuccess({
        appointments: response.data || [],
        totalItems: response.paginationSettings?.totalCount || 0,
        paginationSettings: {
          limit: payload.searchRequest.paginationSettings.limit,
          offset: payload.searchRequest.paginationSettings.offset || 0,
        },
      })
    );
  } catch (error) {
    yield put(
      fetchAppointmentsFailure(
        error instanceof Error
          ? error.message
          : "Failed to fetch appointments"
      )
    );
  }
}

export function* watchAppointments() {
  yield takeLatest(fetchAppointmentsRequest.type, fetchAppointmentsSaga);
}

